"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _arrayWithoutHoles;

var _isArray = _interopRequireDefault(require("../../core-js/array/is-array"));

var _arrayLikeToArray = _interopRequireDefault(require("./arrayLikeToArray"));

function _arrayWithoutHoles(arr) {
  if ((0, _isArray.default)(arr)) return (0, _arrayLikeToArray.default)(arr);
}